const plg = require("../autoload/functions-comunes");
import Swiper from "swiper";
import SwiperCore, { Navigation, Pagination, Autoplay} from 'swiper/core';
SwiperCore.use([Navigation, Pagination, Autoplay,]);

export default {
  init() {
    // JavaScript to be fired on all pages
    setTimeout(function(){
      $('#loading').fadeOut(function(){
        $(this).remove();
      });
    },400);

    window.cambiarPagina = function (){
      const datos = $('#fBuscador').serialize();

      jQuery.ajax({
          method: "POST",
          url: window.global.ajax_url,
          data: datos
      })
      .done(function( msg ) {
          $(".contenedor-busqueda").html(msg);
          plg.PLG_scrollTo(1, '.contenedor-busqueda', 0, -100, 0);
      });
    }

    const swiper = new Swiper('.swiper-related', {
      spaceBetween: 40,
      slidesPerView: 3,
      breakpoints: {
        // when window width is >= 320px
        320: {
          slidesPerView: 1,
          spaceBetween: 20
        },
        // when window width is >= 568px
        568: {
          slidesPerView: 1,
          spaceBetween: 30
        },
        // when window width is >= 768px
        768: {
          slidesPerView: 2,
          spaceBetween: 40
        },
        // when window width is >= 992px
        992: {
          slidesPerView: 3,
          spaceBetween: 40
        }
      },
      
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });
    

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js